<template>
  <div>

    <BackButton v-if="$route.name !== 'landlords'" :namedRoutes="{ landlords: $t('nav.landlords'), landlord: $t('common.landlord')}"></BackButton>

    <add-landlord-view v-if="$route.name === 'add-landlord' || $route.name === 'edit-landlord'" />
    <landlord-details @isDeleted="(boolean) => {isDetailDeleted = boolean}" v-if="$route.name === 'landlord'" :landlord="landlord"/>
    <accounts-table :users="landlord.users" :landlord="landlord" v-if="!isDetailDeleted && Object.keys(landlord).length !== 0 && $route.name === 'landlord'"></accounts-table>

    <BackButton v-if="$route.name !== 'landlords'" :namedRoutes="{ landlords: $t('nav.landlords'), landlord: $t('common.landlord')}"></BackButton>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import BackButton from 'common/BackButton';
import LandlordDetails from './LandlordDetails';
import AccountsTable from './AccountsTable';
import AddLandlordView from './AddLandlordView';

export default {
  components: {
    LandlordDetails,
    AddLandlordView,
    AccountsTable,
    BackButton,
  },
  data() {
    return {
      isDetailDeleted: false,
    };
  },
  computed: mapGetters({
    landlord: 'landlords/landlord/landlord',
  }),
  watch: {
    $route: 'fetchLandlord',
  },
  route: {
    canReuse: true,
  },
  created() {
    this.fetchLandlord();
  },
  methods: {
    fetchLandlord() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('landlords/landlord/fetch', { id: this.$route.params.id, user: this.user, isSuperAdmin: this.isSuperAdmin() }).then(() => {
        });
      } else {
        this.$store.commit(`landlords/landlord/${mTypes.CLEAR_STATE}`);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/landlords/MainView.vue